export default __webpack_public_path__ + "static/og-deloitte-1743df5e98999ba72abee3720978c938.jpg";